/**
 * 설정 화면 UI 문자열 리소스
 * exchange, invest, notifier 설정 관련
 */
export const settingStr = {
  exchange: {
    baseAssetType: '기축자산타입',
    baseAssetTypeTooltip: '자산으로 사용될 Quote 통화',
    useTestnet: '테스트넷 사용',
    useHedgeMode: '헷지 모드 사용',
    hedgeModeTooltip:
      '활성화 시 동일 종목에서 롱/숏 포지션을 동시에 보유할 수 있습니다. 비활성화 시 One-way 모드로 동작합니다.',
    tradingIp: '거래용 IP',
    additionalProxy: '추가 프록시 IP',
    newProxyPlaceholder: '새 프록시 IP',
    holdings: '보유자산',
  },
  invest: {
    seedBasis: '시작 씨드 기준',
    evalSeedBasis: '평가 씨드 기준',
    defaultSeedRatio: '기본 씨드 출자 비율',
    symbolAllocation: '종목당 배분 비율',
    checkBreakInSameCandle: '같은 봉 안에서 돌파 체크',
    tradeLimit: '거래 제한',
    tradeLimitCaption: '같은 봉 안의 직전 진입 가격 기준',
    tradeLimitSuffix: '이내 변동 시 재진입하지 않음',
    tradeErrorRetryLimit: '거래 오류 재시도 제한',
    tradeErrorRetrySuffix: '동안 거래 시도 중단',
    virtualPositionHandling: '가상 포지션 처리',
    backSignalPeriod: '백시그널 기간',
    defaultBacktestPeriod: '기본 백테스트 기간',
    indicatorBufferCandles: '지표 계산용 여유 캔들 수',
    signalProfitCalcBasis: '신호 수익률 계산 기준',
    calcQuantity: '계산 수량',
    virtualSlippage: '가상투자 시 적용 슬리피지',
    entryPriceErrorRange: '진입 가격 오차 범위',
    entryPriceErrorRangeNote: '([가상 투자] 모드에서 포지션 진입 시에만 적용됩니다.)',
  },
  unit: {
    hours: '시간',
    minutes: '분',
    candles: '캔들',
    percent: '%',
  },
  notifier: {
    eventType: '알릴 이벤트',
    sendMethod: '알림 전송 방법',
    allEvents: '모두',
    onlyType: '{type}만',
    apiToken: 'API 토큰',
    webhookUrl: '웹후크 URL',
    inputRequired: '{field}을 입력해주세요.',
    selectNotifierType: '추가할 알림 전송 방법 선택:',
    addNewNotifier: '새 알림 방법 추가',
    restartRequired: '봇 중지 후 재시작이 필요합니다.',
  },
  form: {
    requiredMark: '마크 : 필수 입력',
  },
  message: {
    restartRequired: '수정한 설정이 적용되려면 투자 중지 후 재시작이 필요합니다.',
  },
  button: {
    reset: '초기화',
    validatingProxy: '프록시 검증 중...',
  },
  proxyError: {
    title: '프록시 연결 오류',
    proxyIp: '문제가 발견된 프록시',
    instruction: '프록시 설정을 확인하고 올바른 프록시 IP를 입력해주세요.',
  },
  proxyValidation: {
    failedTitle: '프록시 검증 실패',
    multipleFailures: '{count}개의 프록시 연결 실패',
    otherFailures: '기타 실패한 프록시',
    validationError: '프록시 검증 오류',
    validationErrorMessage: '프록시 검증 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    validatingWarning: '프록시 검증 중입니다. 잠시만 기다려주세요.',
  },
};
